<template>
  <zm-dialog
    class="webinar-explain-dialog-mobile"
    :show-close="true"
    :visible.sync="visibleSync"
    append-to-body
    @close="closeDialog"
  >
    <div class="webinar-explain-dialog_title_mobile">{{ _$t('howAreTheyDifferent') }}</div>
    <span class="explain-header_mobile">{{ _$t('allPlansRequireAZoomOneLicense') }}</span>
    <div class="webinar-explain-dialog_table_mobile">
      <div class="mobile-header">
        <div>
          <span class="main-header">{{ _$t('subscription') }}</span>
          <ToolTips
            :contentText="_$t('subscriptionToolTip')"
            @openTooltip="
              mx_handleOpenTooltip($event, TOOLTIP_TYPES.HEAD__SUBSCRIPTION, {
                content: _$t('subscriptionToolTip'),
                content_en: _$te('subscriptionToolTip'),
                label: _$t('subscription'),
                label_en: _$te('subscription'),
              })
            "
          ></ToolTips>
        </div>
        <div>
          <span class="main-header">{{ _$t('payPerAttendee') }}</span>
          <ToolTips
            :contentText="_$t('ppaToolTips')"
            @openTooltip="
              mx_handleOpenTooltip($event, TOOLTIP_TYPES.HEAD__PAY_PER_ATTENDEE, {
                content: _$t('ppaToolTips'),
                content_en: _$te('ppaToolTips'),
                label: _$t('payPerAttendee'),
                label_en: _$te('payPerAttendee'),
              })
            "
          ></ToolTips>
        </div>
      </div>
      <div
        class="mobile-item"
        v-for="(item, idx) in tableData"
        :key="item.plan"
        :class="[idx % 2 !== 0 ? 'mobile-item_stripe' : '']"
      >
        <div class="mobile-item_name">
          {{ item.plan }}
          <ToolTips
            v-if="item.toolTips"
            :contentText="item.toolTips"
            @openTooltip="
              mx_handleOpenTooltip($event, TOOLTIP_TYPES.BODY__ITEM_TITLE, {
                content: item.toolTips,
                content_en: _$tem(item.toolTips),
                label: item.plan,
                label_en: _$tem(item.plan),
              })
            "
          ></ToolTips>
        </div>
        <div v-if="item.isString" class="mobile-item_content">
          <span class="plan-table_text">{{ item.subscription }}</span>
          <span class="plan-table_text">{{ item.ppa }}</span>
        </div>
        <div v-else class="mobile-item_content">
          <i v-if="item.subscription === true" tabindex="-1" class="zm-icon-ok" :aria-label="_$t('included')"></i>
          <i v-else tabindex="-1" class="zm-icon-minus" :aria-label="_$t('notIncluded')"></i>
          <i v-if="item.ppa === true" tabindex="-1" class="zm-icon-ok" :aria-label="_$t('included')"></i>
          <i v-else tabindex="-1" class="zm-icon-minus" :aria-label="_$t('notIncluded')"></i>
        </div>
      </div>
    </div>
  </zm-dialog>
</template>
<script>
import dialogScript from './scripts';

export default {
  mixins: [dialogScript],
};
</script>
<style lang="scss">
.webinar-explain-dialog-mobile {
  width: 100%;
  .webinar-explain-dialog_title_mobile {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: #222230;
  }
  .explain-header_mobile {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #666487;
  }
  .webinar-explain-dialog_table_mobile {
    margin-top: 20px;
    .mobile-header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eaeaf0;
      .main-header {
        font-size: 14px;
        font-weight: 600;
        line-height: 17px;
        letter-spacing: 0em;
        color: #00031f;
      }
    }
    .mobile-item {
      min-height: 80px;
      padding-top: 10px;
      .mobile-item_name {
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0em;
        color: #00053d;
        margin-bottom: 15px;
        padding-left: 10px;
      }
      .mobile-item_content {
        display: flex;
        justify-content: space-around;
        .plan-table_text {
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
          letter-spacing: 0em;
          color: #00053d;
        }
      }
    }
    .mobile-item_stripe {
      background: #fafafa;
    }
  }
}
</style>
